import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { modalHide } from '../../utils/modal.util';

export interface AppModalUuidQrProps {
  uuid: string;
  label: string;
}

const AppModalUuidQr: React.FunctionComponent<AppModalUuidQrProps> = ({ uuid, label }) => {
  const { lang } = StateLanguage();
  const [clipboard, setClipboard] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(uuid).then(() => {
      setClipboard(true);
      setTimeout(() => {
        setClipboard(false);
      }, 500);
    }).catch(() => {
      setClipboard(false);
    });
  };

  const handleClose = () => {
    modalHide('modal-uuid-qr');
  };

  return (
    <div className="modal fade" id="modal-uuid-qr" tabIndex={-1} aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title">{label}</h3>
            <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" onClick={handleClose}>
              <span className="svg-icon svg-icon-2x">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black"/>
                </svg>
              </span>
            </div>
          </div>
          <div className="modal-body text-center">
            <div className="mb-5">
              <QRCodeSVG value={uuid} size={256} level="M" />
            </div>
            <div className="d-flex align-items-center justify-content-center mb-3">
              <code className="fs-6 me-3">{uuid}</code>
              <button
                className="btn btn-icon btn-sm btn-bg-light btn-active-color-primary"
                type="button"
                onClick={handleCopy}
              >
                <span className="svg-icon svg-icon-1">
                  {!clipboard ? (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path opacity="0.5" d="M18 2H9C7.34315 2 6 3.34315 6 5H8C8 4.44772 8.44772 4 9 4H18C18.5523 4 19 4.44772 19 5V16C19 16.5523 18.5523 17 18 17V19C19.6569 19 21 17.6569 21 16V5C21 3.34315 19.6569 2 18 2Z" fill="black"/>
                      <path fillRule="evenodd" clipRule="evenodd" d="M14.7857 7.125H6.21429C5.62255 7.125 5.14286 7.6007 5.14286 8.1875V18.8125C5.14286 19.3993 5.62255 19.875 6.21429 19.875H14.7857C15.3774 19.875 15.8571 19.3993 15.8571 18.8125V8.1875C15.8571 7.6007 15.3774 7.125 14.7857 7.125ZM6.21429 5C4.43908 5 3 6.42709 3 8.1875V18.8125C3 20.5729 4.43909 22 6.21429 22H14.7857C16.5609 22 18 20.5729 18 18.8125V8.1875C18 6.42709 16.5609 5 14.7857 5H6.21429Z" fill="black"/>
                    </svg>
                  ) : (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path opacity="0.5" d="M12.8956 13.4982L10.7949 11.2651C10.2697 10.7068 9.38251 10.7068 8.85731 11.2651C8.37559 11.7772 8.37559 12.5757 8.85731 13.0878L12.7499 17.2257C13.1448 17.6455 13.8118 17.6455 14.2066 17.2257L21.1427 9.85252C21.6244 9.34044 21.6244 8.54191 21.1427 8.02984C20.6175 7.47154 19.7303 7.47154 19.2051 8.02984L14.061 13.4982C13.7451 13.834 13.2115 13.834 12.8956 13.4982Z" fill="black"/>
                      <path d="M7.89557 13.4982L5.79487 11.2651C5.26967 10.7068 4.38251 10.7068 3.85731 11.2651C3.37559 11.7772 3.37559 12.5757 3.85731 13.0878L7.74989 17.2257C8.14476 17.6455 8.81176 17.6455 9.20663 17.2257L16.1427 9.85252C16.6244 9.34044 16.6244 8.54191 16.1427 8.02984C15.6175 7.47154 14.7303 7.47154 14.2051 8.02984L9.06096 13.4982C8.74506 13.834 8.21146 13.834 7.89557 13.4982Z" fill="black"/>
                    </svg>
                  )}
                </span>
              </button>
            </div>
            <p className="text-muted fs-7">{lang.labels.scanToAddMeAsContact}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppModalUuidQr;
